const AFTER_ORDER_STEPS = [
  {
    title: "Our editors get to work",
    description: "Everything is delivered within 24 hours.",
  },
  {
    title: "You'll get an email when it's ready",
    description: "Your videos will be waiting in your dashboard.",
  },
  {
    title: "Free edits until you're happy",
    description: "Tell us what to change and we'll fix it.",
  },
];

export default function AfterOrderSteps() {
  return (
    <div className="flex flex-col gap-3">
      <p className="font-medium">What happens after ordering</p>
      <div className="flex flex-col gap-4 rounded-xl border px-6 py-4">
        {AFTER_ORDER_STEPS.map((item, index) => (
          <div key={item.title} className="flex items-center gap-5">
            <span
              className="flex size-6 shrink-0 items-center justify-center rounded-full border border-transparent text-sm font-semibold"
              style={{
                background:
                  "linear-gradient(to bottom right, var(--color-primary-100), var(--color-secondary-100)) padding-box, linear-gradient(to bottom right, color-mix(in srgb, var(--color-primary-400) 30%, transparent), color-mix(in srgb, var(--color-secondary-400) 30%, transparent)) border-box",
              }}
            >
              <span className="bg-linear-to-br from-primary-400 to-secondary-400 bg-clip-text text-transparent">
                {index + 1}
              </span>
            </span>
            <div className="flex min-w-0 flex-col">
              <p className="text-sm font-medium">{item.title}</p>
              <p className="text-sm text-text-secondary">{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
